export const REPO_MARKDOWN_IMPORT_COOLDOWN_MS = 30_000;
export const REPO_MARKDOWN_IMPORT_COOLDOWN_SECONDS =
  REPO_MARKDOWN_IMPORT_COOLDOWN_MS / 1_000;

export function repoMarkdownImportCooldownStorageKey() {
  return "repo-markdown-import-cooldown-until";
}

function readCooldownUntilMs(): number | null {
  try {
    const key = repoMarkdownImportCooldownStorageKey();
    const raw = window.sessionStorage.getItem(key);

    if (!raw) {
      return null;
    }

    const until = Number(raw);

    if (!Number.isFinite(until)) {
      window.sessionStorage.removeItem(key);
      return null;
    }

    return until;
  } catch {
    return null;
  }
}

export function readRepoMarkdownImportCooldownRemainingSeconds(
  now = Date.now(),
): number | null {
  const until = readCooldownUntilMs();

  if (until === null) {
    return null;
  }

  const remainingSeconds = Math.ceil((until - now) / 1_000);

  if (remainingSeconds <= 0) {
    clearRepoMarkdownImportCooldown();
    return null;
  }

  return remainingSeconds;
}

export function writeRepoMarkdownImportCooldownUntil(epochMs: number) {
  try {
    window.sessionStorage.setItem(
      repoMarkdownImportCooldownStorageKey(),
      String(epochMs),
    );
  } catch {
    // sessionStorage may be unavailable (private mode / quota); UI still works.
  }
}

export function clearRepoMarkdownImportCooldown() {
  try {
    window.sessionStorage.removeItem(repoMarkdownImportCooldownStorageKey());
  } catch {
    // Ignore storage failures when clearing.
  }
}

export function startRepoMarkdownImportCooldown(
  durationSeconds: number,
  now = Date.now(),
) {
  const seconds = Math.max(1, Math.ceil(durationSeconds));
  writeRepoMarkdownImportCooldownUntil(now + seconds * 1_000);
  return seconds;
}
